

// -----------------------New code--------------------------

import React, { useEffect, useState } from "react";
import BackBar from "../home/BackBar";
import {
  ADDTO_LIST,
  MYLISTS,
  RECOMMENDED_CANDIDATES,
  RECRUITER_PLAYLIST,
} from "../../Service/service";
import { deleteData, getData } from "../../Service/ApiMethod";
// import { async } from "q";
// import CanNearmeBlackScreen from "../home/component/CanNearmeBlackScreen";
import MyListBlackscreen from "./MyListBlackscreen";
import { useTranslation } from "react-i18next";
import Header from "../../common/HeaderAfterLogin";
import Footer from "../../common/Footer";

const MyLists = (props) => {
  const [list, setList] = useState();
  const [listerr, setListerr] = useState();
  const [addlist, setAddlist] = useState();
  const [addlistErr, setAddListErr] = useState([]);
  // const [id, setId] = useState();
  const [playlist, setPlaylist] = useState([]);
  const [playlisterr, setPlaylisterr] = useState([]);
  const [filteredData, setFilteredData] = useState();
  const [showlist, setShowlist] = useState(false);
  const [blackScreen, setBlackScreen] = useState(false)
  const [candIndexing, setCandIndexing] = useState()
  const [iindex, setIindex] = useState()
  const [userId, setUserId] = useState()
  const [deletePopup, setDeletePopup] = useState()
  const [popup, setPopup] = useState(false)


  // const [ATLIndexing, setATLIndexing] = useState()

  // const obj = {
  //   id: id,
  // };

  const handleFilterData = (title) => {

    const filterArray = playlist?.filter((item) => { return (item?.first_name && (item?.playlist == title)) });
    setFilteredData(filterArray);
    if (filterArray?.length > 0) {
      setShowlist(true);
    } else {
      // alert('List is empty')
    }
  };
  console.log("filteredData", filteredData);

  const handleClick = async () => {
    await getData(ADDTO_LIST)
      .then((response) => response.json())
      .then((data) => {
        console.log("res data", data);
        setPlaylist(data?.data);
      })
      .catch((err) => {
        console.log("Error in categories from get Form", err);
        console.log(" code Error", err);
        setPlaylisterr(err.message);
        console.log(setPlaylist);
      });
  };
  console.log("playlist", playlist);

  const getaddlists = () => {
    getData(ADDTO_LIST)
      .then((response) => {
        response.json();
      })
      .then((data) => {
        setAddlist(data.data);
        console.log("addlist", addlist);
      })
      .catch((err) => {
        console.log("Error in categories from get Form", err);
        console.log(" code Error", err);
        setAddListErr(err.message);
        console.log(setAddlist);
      });
  };
  useEffect(() => {
    getaddlists();

    handleClick();
  }, []);

  useEffect(() => {
    handleClick()
    setList();
    getlist();
    getaddlists();
    handleFilterData()
  }, [popup])

  useEffect(() => {
    handleClick()
    setList();
    getlist();
    handleFilterData()
  }, [])

  const getlist = () => {
    getData(MYLISTS)
      .then((response) => response.json())
      .then((data) => {
        setList(data?.data);

      })
      .catch((err) => {
        console.log("Error in categories from get Form", err);
        console.log(" code Error", err);
        setListerr(err.message);
        // console.log(setList.user_id);
      });
  };

  // const deleteVaccancy = async () => {
  //   const obj = {
  //     id: localStorage.getItem("vaccancy_id")
  //   };
  //   await deleteData(obj, )
  //     .then((res) => res.json())
  //     .then((data) => alert(data.message))
  //   setDeletePopup(false)
  // }



  const deleteTilte = () => {
    const obj = {
      id: userId,
    };
    deleteData(obj, ADDTO_LIST)
      .then((res) => res.json())
      .then((data) => alert(data?.message));
    setDeletePopup(false);
    handleClick();


  };
  useEffect(() => {
    setList();
    getlist();

  }, []);
  console.log("List", list);
  console.log("listerr", listerr);
  console.log("addlistErr", addlistErr);

  const { t } = useTranslation();

  return (
    <>
      <Header />
      <div className="wrapped-content-area pt-3" style={{}}>
        <BackBar title={t("My Lists")} />
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3 col-sm-12 px-0 listcontainerout">
              {list?.length != 0 ?
                list?.map((item, index) => {
                  return (
                    <div key={index}
                      className='listcontainer'
                      onClick={() => {
                        handleFilterData(item?.title)
                        setDeletePopup(false)

                        // requiredCandidate(item?.title)
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      {/* <hr className="line" /> */}
                      <div className="profiles-box" >
                        <div className="" style={{ display: 'flex', justifyContent: 'space-between',alignItems:'center' }}>
                         
                            <span className="text"> {item?.title}</span>
                      
                          <img
                            src="./images/go-arrow.png"
                            alt=""
                            className="listarrowimage" style={{
//                               position: 'absolute',
// right: 0
                            }}
                          // style={{width:'9%', height:'4%'}}
                          // onClick={() => ADDTO_LIST(item.id)}
                          />
                        </div>
                      </div>
                    </div>
                  );
                }) : <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  {/* <h4>{t('No Candidate Available')}!</h4> */}

                </div>}
            </div>
            <div className="col-lg-8 col-md-8 col-sm-12" style={{ display: "grid", gridRow: "auto" }}>
              {showlist &&
                filteredData?.length != 0 ?
                (filteredData?.map((item, index) => (


                  // _____



                  // ++++
                  <div
                    // className="listProfileContainer "
                    onClick={(e) => {
                      e.stopPropagation()
                      setBlackScreen(true)
                      setCandIndexing(index)
                      console.log("itemdata", item)
                    }}
                    key={index}>
                    {/* <div className="row "
                      onClick={(e) => {
                        e.stopPropagation()
                        setBlackScreen(true)
                        setCandIndexing(index)
                        console.log("itemdata", item)
                      }}
                      > */}
                    <div className="recommended-profile" id={item.id} key={item.id}>
                      {/* <div className=""> */}
                      <div className="row">
                        <div className="col-md-2 col-sm-12 px-0 relative flex-center">
                          <div className="outer-box">
                          {item?.is_premium &&
                            <div className="premium-tag-outer" style={{  }}>
                              <img
                                src="./images/premium-tag.png"
                                className="premium-tag"
                                // title="Call"
                                alt=""
                              />
                            </div>
                          }
                          <img
                              src={item?.applicant_profile_pic}
                              alt=""
                              className="profile-img"
                            // style={{ width: 'inherit' }}
                            /> 
                       
                          
                          </div>
                       

                          {/* <img
                                  src="./images/save-profile.png"
                                  alt=""
                                  className="save-profile"
                                /> */}

                          {props?.bottom}
                        </div>
                        <div className="col-md-10 col-sm-12 pr-0">
                          <h2 className="card-heding relative">
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() => props.openDetailPopup()}
                            >
                              {item.first_name + " " + item.last_name}
                            </span>
                            {/* <i className="fa fa-pencil"  aria-hidden="true" style={{position:"absolute",right:"23px"}} >  </i>
                                  <i className="fa fa-trash" aria-hidden="true" style={{position:"absolute",right:"3px"}} ></i> */}
                            {/* <img
                                    src="./images/send-job.png"
                                    
                                    alt=""
                                    className="addprofile"
                                    onClick={() => {
                                      setId(item.id);
                                      // deleteHandler()
                                    }}
                                  /> */}
                            <img
                              src="./images/pencilBlack.png"
                              alt=""
                              style={{ }}
                              className="addprofile side-icon"
                              key={index}
                              id={item?.id}
                              onClick={(e) => {
                                e.stopPropagation()
                                setDeletePopup(!deletePopup)
                                setIindex(index)
                                setUserId(item?.id)
                              }}
                            />


                            {((iindex === index) && deletePopup) &&

                            

                                <div className="removepen" style={{ border: '1px solid black', textAlign: 'center', borderRadius: '2px', cursor: 'pointer', backgroundColor: 'whitesmoke' }} onClick={(e) => {
                                  e.stopPropagation()
                                  deleteTilte()
                                  setDeletePopup(!deletePopup)
                                }}>{t('Remove')}</div>
                         
                            }
                            {/* {item?.is_verified ? (
                                    <>
                                      <img src="./images/verified.png" alt="" />
                                      <span className="verified">Verified</span>
                                    </>
                                  ) : null} */}
                          </h2>

                          <p className="designation">
                            {item?.profile_title}
                          </p>



                          {(parseInt(item?.availability)) > 0 &&
                            <p className="profile-availbility">
                              ({t('Available')} {item?.availability})
                            </p>
                          }
                          {/* <div className="row mt-2"> */}
                          <div className="col-12 px-0">


                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              // border:'1px solid black'
                            }} >
                              <p className="card-subHeading">
                                {t('Total Experience')}
                              </p>
                              <p className="profile-info">
                                {item?.experience} {item?.experience > 1 ? `${t('Years')}` : `${t('Year')}`}
                              </p>



                              {/* <p className="horizontal-center">
                                      <img
                                        src="./images/match-badge.png"
                                        className="img-size18"
                                        alt=""
                                      />
                                      <span className="ms-1 match-profile">
                                        {item.percentage_match} Match
                                      </span>
                                    </p> */}
                            </div>

                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              // border:'1px solid black'
                            }} > <p className="card-subHeading">
                                {t('Work Location')}
                              </p>
                              <p className="profile-info">
                                {parseInt(item?.distance)} {t('KM Away')}
                              </p>

                            </div>

                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              // border:'1px solid black'
                            }}>
                              <p className="card-subHeading">{t('Package')}</p>
                              <p className="profile-info">
                                {item?.currency} {item?.expected_salary} {item?.compensation_details}
                              </p>
                            </div>

                            {/* <div className="col-6 px-0"> */}



                            {/* <p className="profile-last-seen">
                                      <span className="last-seen">
                                        last Seen
                                      </span>
                                      {item.last_seen}
                                    </p> */}
                            {/* </div> */}
                          </div>
                        </div>
                      </div>
                      {/* </div> */}
                    </div>
                    {/* </div> */}
                    {(candIndexing === index) && blackScreen &&
                      <div className='blur-screen-full-area flex-center ' style={{ position: 'fixed', top: '0', zIndex: '99999999999999', height: '100vh', overflow: 'auto', background: 'rgb(0, 0, 0, 0.7' }} >
                        <MyListBlackscreen setPopup={setPopup} popup={popup} Candidate={item} setBlackScreen={setBlackScreen} />
                      </div>
                    }
                  </div>
                ))) : <>{filteredData?.length == 0 &&
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <h4 className="list-header">{t('No Candidate Available')}!</h4>

                  </div>}
                </>
              }

            </div>
          </div>
        </div>

      </div>
      <Footer />
    </>
  );
};

export default MyLists;

